import { render, staticRenderFns } from "./BarcodeSettings.vue?vue&type=template&id=1f4ab18b&scoped=true"
import script from "./BarcodeSettings.vue?vue&type=script&lang=ts"
export * from "./BarcodeSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ab18b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f4ab18b')) {
      api.createRecord('1f4ab18b', component.options)
    } else {
      api.reload('1f4ab18b', component.options)
    }
    module.hot.accept("./BarcodeSettings.vue?vue&type=template&id=1f4ab18b&scoped=true", function () {
      api.rerender('1f4ab18b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/BarcodeSettings.vue"
export default component.exports